import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import coursjusReducer from './reducers/courtjusSlice';
import { USER_INIT } from './constants/globals';

import { createStore } from "redux";
import { Provider } from "react-redux";


const saveToLocalStorage = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (e) {
    console.error(e);
  }
};


const defaultState = {
  msg: "", //message d'alerte si besoin
  userMenu: false, // affichage menu utilisateur ou la demande de connection
  userCJ: USER_INIT // session utilisateur
};

const loadFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) return undefined;

    const parsedState = JSON.parse(serializedState);

    // 2. On fusionne l'état par défaut avec l'état sauvegardé
    // De cette façon, si une clé manque dans le localStorage, elle prend la valeur par défaut
    return {
      ...defaultState,
      ...parsedState
    };
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

const persistedState = loadFromLocalStorage();


const root = ReactDOM.createRoot(document.getElementById('root'));

const store = createStore(
  coursjusReducer,
  persistedState,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);


store.subscribe(() => {
  saveToLocalStorage(store.getState());
});

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
